<template>
  <div style="width: 100%">
    <el-button size="small" @click="dowLoad">下载数据</el-button>
    <el-table
      header-row-class-name="data-table-header-style"
      :data="sourceTable"
      style="width: 100%;height:500px;overflow-y:auto;margin:10px 0"
    >
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column
        :width="item.width"
        v-for="item in productProps"
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
      >
        <template slot-scope="scope">
          <div>
            <span>{{scope.row[item.prop]}}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    sourceTable: {
      type: Array,
      required: true
    },
    productProps: {
      type: Array,
      required: true
    },
    type: {
      type: Number
    }
  },
  data() {
    return {};
  },
  methods: {
    dowLoad() {
      this.$emit("dowLoad");
    }
  }
};
</script>
<style lang="scss">
@import "src/style/tableCommon";
</style>